import { getEnumValues } from "@common/enumOperations.ts";
import { setFirstLetterToLowerCase } from "@common/stringOperations.ts";
import { DotLegalSelectOption } from "@common/components/dotLegalMultiSelect/DotLegalMultiSelect.types.ts";
import { ProcessStatus } from "./Process.types.ts";

export function getProcessStatusTranslationKey(status: ProcessStatus) {
    return setFirstLetterToLowerCase(ProcessStatus[status]);
}

export function getProcessStatusOptions(translateString: (key: string) => string): Array<DotLegalSelectOption> {
    return getEnumValues(ProcessStatus).map((x) => {
        return { id: x.toString(), name: translateString(getProcessStatusTranslationKey(x)) };
    });
}
